import { render, staticRenderFns } from "./NotesFormNew.vue?vue&type=template&id=0ca13194"
import script from "./NotesFormNew.vue?vue&type=script&lang=js"
export * from "./NotesFormNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports